import styled from 'styled-components'

interface BreadcrumbLinkProps {
  isCurPage: boolean
}

export const BreadcrumbContainer = styled.div`
  height: 50px;
  margin-bottom: 16px;
  
  @media (max-width: 575px) {
    height: auto;
  }
`

export const BreadcrumbWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  row-gap: 4px;
`

export const BreadcrumbItem = styled.span`
  flex-shrink: 0;
`

export const BreadcrumbItemWithIcon = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`

export const BreadcrumbLink = styled.a<BreadcrumbLinkProps>`
  position: relative;
  font-size: 0.9rem;
  text-decoration: none;
  font-family: Roboto;
  transition: all 0.2s ease;
  cursor: ${(props) => (props.isCurPage ? 'default' : 'pointer')};
  color: ${(props) => (props.isCurPage ? 'var(--text-primary)' : 'var(--primary)')};
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;

  @media (min-width: 768px) {
    max-width: none;
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
  }
  
  :hover{
    color: ${(props) => (props.isCurPage ? 'var(--text-secondary)' : 'var(--secondary-c)')};
  }
`
